import { Config } from 'final-form';

import { AudienceFragment, OfferFragment } from '@occc/graphql';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';

import {
  getInAudienceConstraintInitialValues,
  getInAudienceConstraintOperations,
  getLocationInStateConstraintInitialValues,
  getLocationInStateConstraintOperations,
  getStoreLocationOrGroupsConstraintOperations,
  getSubBrandConstraintOperations,
  StoreLocationOrGroupsFormValues,
  SubBrandConstraintFormValues,
} from '@occc/feat-constraints';
import { TargetFormValues } from './types';

export const getInitialValues = (
  offer: OfferFragment | null | undefined,
  storeLocationOrGroups: StoreLocationOrGroupsFormValues,
  audience?: AudienceFragment,
  subBrand?: SubBrandConstraintFormValues,
): Config<TargetFormValues>['initialValues'] => ({
  ...getInAudienceConstraintInitialValues(offer, audience),
  ...getLocationInStateConstraintInitialValues(offer),
  ...storeLocationOrGroups,
  ...subBrand,
});

export const getTargetsOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: TargetFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => [
  ...getInAudienceConstraintOperations(offerId, values, dirtyFields),
  ...getLocationInStateConstraintOperations(offerId, offer, values, dirtyFields),
  ...getStoreLocationOrGroupsConstraintOperations(
    offerId,
    offer,
    values.storeLocationOrGroups,
    dirtyFields,
  ),
  ...getSubBrandConstraintOperations(offerId, offer, values, dirtyFields),
];
